module.exports = __webpack_public_path__ + "img/image-piccollo.cb854eff.png";